export default __webpack_public_path__ + "media/images/brands/nkuku-5fd83faac6875f6139d0275cf7d50a04.png";